<template>
  <div class="chart">
    <Chart></Chart>
  </div>
</template>

<script>
import Chart from "./Comparison.js";

export default {
  components: {
    Chart
  }
};
</script>

<style>
.chart{
  width: 100%;
}
</style>